import {Component, EventEmitter, Injector, Input, Output} from '@angular/core';
import {ControllerComponent} from './controller-component';
import {WidgetDto} from '../../Models/Widgets/widget.interface';
import {WidgetsManagerService} from '../../Services/Shared/widgets-manager.service';

@Component({
  selector: 'app-widget-controller',
  template: '',
  standalone: false
})
export abstract class WidgetControllerComponent extends ControllerComponent {

  @Input() widget!: WidgetDto;
  @Input() isStoreView!: boolean;

  @Input() subheader: string = '';

  @Output() clickWidget: EventEmitter<void> = new EventEmitter<void>();

  widgetsManager: WidgetsManagerService;

  protected constructor(
    protected override injector: Injector
  ) {
    super(injector);

    this.widgetsManager = this.injector.get<WidgetsManagerService>(WidgetsManagerService);
  }


  /**
   * Hacer click en el widget
   *
   */
  onClickWidget(extraData?: any) {

    if (extraData) {
      this.widget.data = {...this.widget.data, extraData};
    }

    this.clickWidget.emit();
  }

}
